/**
 * AP-11 — gemeinsame Typen der Trace-Codecs.
 * Gegenstück zu `ITraceWriter.h` / `ITraceReader.h`.
 */

import type { CanFrame } from '../can/ICanAdapter';

export type TraceFormat = 'asc' | 'trc';

/** Zustandsbehaftet, weil TRC seine Nachrichten fortlaufend nummeriert. */
export interface TraceWriter {
  /** Kopfzeilen, genau einmal am Dateianfang. */
  header(): string;
  /** Eine Zeile inklusive abschließendem `\n`. */
  frame(frame: CanFrame, isRx: boolean): string;
}

/** Gegenstück zu `ReadNext()`: `null` bedeutet „Zeile überspringen". */
export type TraceLineParser = (line: string) => CanFrame | null;

/** Klemmt auf 0..8 — Vertragspflicht für jeden Frame-Erzeuger (CONTRACTS.md §1). */
export function clampDlc(value: number): number {
  if (!Number.isFinite(value) || value < 0) return 0;
  return value > 8 ? 8 : Math.floor(value);
}

/** `std::stoul(tok, nullptr, 16)`-Ersatz; `null` statt Ausnahme bei Unsinn. */
export function parseHex(token: string): number | null {
  if (!/^[0-9a-fA-F]+$/.test(token)) return null;
  const value = Number.parseInt(token, 16);
  return Number.isFinite(value) ? value >>> 0 : null;
}

/** Datenbytes ab `dlc`; das Original lässt sie bei Lesefehlern auf 0. */
export function parseDataBytes(tokens: readonly string[], dlc: number): Uint8Array {
  const data = new Uint8Array(8);
  for (let i = 0; i < dlc; i += 1) {
    const token = tokens[i];
    if (token === undefined) break;
    data[i] = parseHex(token) ?? 0;
  }
  return data;
}

export function formatDataBytes(frame: CanFrame): string {
  let out = '';
  for (let i = 0; i < frame.dlc && i < 8; i += 1) {
    out += ` ${(frame.data[i] ?? 0).toString(16).toUpperCase().padStart(2, '0')}`;
  }
  return out;
}
